const teachingData = [
//   {
//     title: "CS 391: Ethical Issues in Computer Science",
//     year: "2023-2024",
//     level: "undergraduate",
//     students: "40",
//     university: "Oregon State University-Cascades",
//   },
  {
    title: "Ethics of Technology (Computer Science)",
    year: "2024",
    level: "undergraduate",
    students: "30",
    university: "Oregon State University-Cascades",
  },
  {
    title: "The Philosophy of Virtual Worlds",
    year: "2022",
    level: "honours",
    students: "25",
    university: "University of Edinburgh",
  },
  {
    title: "Introduction to Ethics",
    year: "2012-2013",
    level: "undergraduate",
    students: "200",
    university: "University of Illinois",
  },
  {
    title: "Symbolic Logic",
    year: "2013–2023",
    level: "undergraduate",
    students: "400+",
    university: "University of Edinburgh",
  },
  {
    title: "Modal Logic",
    year: "2019-2021",
    level: "undergraduate",
    students: "40",
    university: "University of Edinburgh",
  },
  {
    title: "Techniques of Argumentation",
    year: "2012-2013",
    level: "undergraduate",
    students: "200",
    university: "University of Illinois",
  },
  {
    title: "Metalogic",
    year: "2012-2013",
    level: "undergraduate",
    students: "40",
    university: "University of Illinois",
  },
  {
    title: "Philosophy of Language",
    year: "2014–2018",
    level: "honours",
    students: "30",
    university: "University of Edinburgh",
  },
  {
    title: "Frege, Russell, and Wittgenstein",
    year: "2022",
    level: "honours",
    students: "30",
    university: "University of Edinburgh",
  },
  {
    title: "Kripke's Naming and Necessity",
    year: "2014",
    level: "honours",
    students: "30",
    university: "University of Edinburgh",
  },
  {
    title: "Mind, Matter, and Language",
    year: "2018–2019",
    level: "undergraduate",
    students: "300+",
    university: "University of Edinburgh",
  },
  {
    title: "Philosophy of Linguistics",
    year: "2018–2019",
    level: "MSc",
    students: "15",
    university: "University of Edinburgh",
  },
  {
    title: "Contemporary Debates in Language",
    year: "2019–2020",
    level: "MSc",
    students: "15",
    university: "University of Edinburgh",
  },
  {
    title: "Puzzles and Paradoxes",
    year: "2015–2022",
    level: "honours",
    students: "35",
    university: "University of Edinburgh",
  },
  {
    title: "The Philosophy of David Lewis",
    year: "2019–2021",
    level: "honours",
    students: "25",
    university: "University of Edinburgh",
  },
  {
    title: "Paradoxes",
    year: "2017",
    level: "undergraduate",
    students: "40",
    university: "Dartmouth College",
  },
  {
    title: "Introduction to Philosophy",
    year: "2012-2013",
    level: "undergraduate",
    students: "200+",
    university: "University of Illinois",
  },
];

export default teachingData;
